import { useDispatch, useSelector } from 'react-redux';
import { FlexContainer, Text, Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import { hideModalAction } from 'Store/modules/app/actions';
import { routeStateSelector } from 'Store/modules/router/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { removeOverflow } from 'Styles/utils/utils';
import { routes } from 'Constants/routes';
import * as Styled from './styles';

const EntertaimentModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation(locizeNS.MODALS);
  const isPreviousYears = useSelector(routeStateSelector);
  const handleRedirect = (route: string): void => {
    history.push(route, {
      products: isPreviousYears?.products ?? {},
    });
    removeOverflow();
    dispatch(hideModalAction());
  };

  return (
    <Styled.ModalContainer align="center" justify="center">
      <Styled.ModalContent direction="column">
        <Styled.Container direction="column">
          <Text type="headline" color="dark" size="XS_L_S" align="center" mb="fds_size_08">
            {t('Entertaiment.Title')}
          </Text>
          <Text type="paragraphs" color="grey" size="XS_L_S" align="center" mb="fds_size_32">
            {t('Entertaiment.subtitle')}
          </Text>
          <FlexContainer gap="dimension_16" align="center" justify="center">
            <Buttons.Classic
              onClick={() => handleRedirect(routes.DASHBOARD)}
              label={t('Entertaiment.button.dashboard')}
              size="xs"
              mode="secondary"
            />
            <Buttons.Classic
              onClick={() => handleRedirect(routes.DATAGATHERING_LOADER)}
              label={t('Entertaiment.button.loader')}
              mode="primary"
              size="xs"
            />
          </FlexContainer>
        </Styled.Container>
      </Styled.ModalContent>
    </Styled.ModalContainer>
  );
};

export default EntertaimentModal;
